export default "__VITE_ASSET__BpiMUNzw__"